import Vue from 'vue'
import Vuex from 'vuex'
import userManage from './modules/userManage.js'
import routerManage from './modules/routerManage.js'
import loginManage from './modules/loginManage.js'
import dataManage from './modules/dataManage.js'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  modules: {
    userManage,
    routerManage,
    loginManage,
    dataManage
  }
})
